var core = module.exports = {version: '1.2.6'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/core-js/library/modules/$.core.js
// module id = 491
// module chunks = 2